import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "./styles/variables.css";
import App from "./app/app";
import { initWebEngage } from "./custom_utilities/webengage/webengageInit";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import LoaderPopUp from "./components/loader/loader";

import { Provider } from "react-redux";
import { store, persistor } from "./redux/store/store";
import { PersistGate } from "redux-persist/es/integration/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";

initWebEngage();

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

const queryClient = new QueryClient();
ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <PersistGate loading={<LoaderPopUp />} persistor={persistor}>
        <HelmetProvider>
          <App onContextMenu={(e) => e.preventDefault()} />
        </HelmetProvider>
      </PersistGate>
    </Provider>
  </QueryClientProvider>,
  document.querySelector("#root")
);
